import styles from './style.module.css';
import {ComponentWithChildrenProps} from '@interfaces/component';

export function ProductTabNav({children}: ComponentWithChildrenProps) {
  return <ul className={`${styles.productTabNav}`}>{children}</ul>;
}
